import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { isEmpty, reduce, isNil, pickBy, cloneDeep, forEach } from 'lodash';
import * as syncActions from '../../../redux/actionCreators/sync';
import {getSchema as getJobSchema} from '../../../models/jobRequest';
import { validate } from '../../../modelValidator';
import SubNavigation from '../SubNavigation';
import JobRequestLinks from '../SubNavigation/JobRequestLinks';
import { skillCategoryTypesByTenant } from '../../../redux/helpers/staticData';

@connect((store) => ({
  user: store.user,
  jobRequest: store.jobRequest,
  documents: store.jobRequestDocuments.documents,
  contactProfile: store.contactProfile,
  staticData: store.staticData,
  labels: store.labels.jobRequest,
  bqpMigrationFeature: store.staticData.featureToggles.find(feature => feature.hardcodelink === 'BQP_MIGRATION_FEATURE').value === true

}))
export default class JobRequest extends Component {
  static propTypes = {
    dispatch : PropTypes.func.isRequired,
    params: PropTypes.object,
    user: PropTypes.object,
    children: PropTypes.any,
    location: PropTypes.object,
    jobRequest: PropTypes.object,
    route: PropTypes.object,
    documents: PropTypes.any,
    contactProfile: PropTypes.object,
    staticData: PropTypes.object,
    labels: PropTypes.object,
    bqpMigrationFeature: PropTypes.bool
  }

  constructor(props, context) {
    super(props, context);

    this.checkJobRequestSectionCompletion = ::this.checkJobRequestSectionCompletion;
    this.jobRequestSchema = ::this.jobRequestSchema;

    this.state = {
      activeLink: 'Position Info',
      jobRequestCompletion: {
        position: false,
        description: false,
        adddocuments: false,
        skills: false,
        summary: false,
        workschedule: false,
        addcontact: false,
      },
    };

  }

  componentDidMount() {

    if(!isNil(this.props.params.jobId)) {
        this.checkJobRequest();
    }

    this.props.dispatch(syncActions.setNavState({isOpen: false, hideClose: false}));
  }

  getActiveLink() {
    const routeArray = this.props.location.pathname.split('/');
    const routeTail = routeArray[routeArray.length -1];
    let activeLinkText = 'Position Info';

    switch (routeTail) {
      case 'description':
        activeLinkText = 'Job Description';
        break;
      case 'adddocuments':
        activeLinkText = 'Add Documents';
        break;
      case 'skills':
        activeLinkText = 'Skills';
        break;
      case 'summary':
        activeLinkText = 'Summary of Skills';
        break;
      case 'workschedule':
        activeLinkText = 'Work Schedule';
        break;
      case 'addcontact':
        activeLinkText = 'Reporting';
        break;
      case 'authorize':
        activeLinkText = 'Authorize';
        break;

      default:
        if (routeArray[routeArray.length - 2] == 'skills') {
          activeLinkText = 'Skills';
        }
        break;
    }

    return activeLinkText;
  }

  jobRequestSchema(section) {
    const schema = cloneDeep(getJobSchema()[section]);

    if (this.props.labels) {
      forEach(this.props.labels[section], (val, key) => {
        if (!this.props.labels[key]) delete schema[key];
      });
    }

    return schema;
  }

  checkJobRequest() {
    const skills = pickBy(this.props.jobRequest.skills, (skill) => skill.length > 0);
    const isSkillValid = (skill) => isNil(skill) || skill.name === 'None' || !isNil(skill.skillOption);
    const isSkillCategoryValid = (cat) => reduce(cat, (acc, skill) =>   isSkillValid(skill) && acc, true);
    const areAllSkillCategoriesValid = (skills) => reduce(skills, (acc, category) => isSkillCategoryValid(category) && acc, true);
    const validSummary = areAllSkillCategoriesValid(skills);
    const {
      skillCategoryTypes = [],
      account = {}
    } = this.props.staticData;

    const requiredCategoryTypes = skillCategoryTypesByTenant(account.id, skillCategoryTypes);
    const filledCategoryTypes = Object.keys(skills || {});
    let areAllSkillCategoriesFilled = true;
    requiredCategoryTypes.forEach(x => {
      if (filledCategoryTypes.find(g => g === x.id.toString()) === undefined) {
        areAllSkillCategoriesFilled = false;
      } else {
        if (skills.hasOwnProperty(x.id.toString())) {
          if (skills[x.id.toString()].length === 0) {
            areAllSkillCategoriesFilled = false;
          }
        }
      }
    });

    // Menu item should have item name and status of passed validation

    const jobRequestCompletion = {
      position: validate(this.props.jobRequest, this.jobRequestSchema('position')).length === 0,
      adddocuments: !isEmpty(this.props.documents),
      description: !isNil(this.props.jobRequest.description),
      workschedule: validate(this.props.jobRequest, this.jobRequestSchema('workschedule')).length === 0,
      addcontact: false,
      skills: areAllSkillCategoriesFilled,
      summary: areAllSkillCategoriesFilled && validSummary,
    };

    this.setState({jobRequestCompletion});

  }


  // eslint-disable-next-line no-unused-vars
  checkJobRequestSectionCompletion(menuItem) {
    // revalidate every time user click next.
    this.checkJobRequest();
  }


  render() {
    this.state.activeLink = this.getActiveLink();

    return (
      <div className='job-request'>
        { // omit if BQP_MIGRATION_FEATURE on
          !this.props.bqpMigrationFeature &&
          <SubNavigation title='Job Request'>
            <JobRequestLinks
              jobId = {this.props.params.jobId}
              route= {this.props.route}
              params= {this.props.params}
              activeLink  = {this.state.activeLink}
              completed = {this.state.jobRequestCompletion}
              dispatch={this.props.dispatch} />
          </SubNavigation>
        }
        {React.cloneElement(this.props.children, { checkComplete: this.checkJobRequestSectionCompletion, completed: this.state.jobRequestCompletion })}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/index.js